import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ProgressIndicatorSpinnerIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M1.76 14.33c-.17-.76-.26-1.55-.26-2.33h1c0 .71.08 1.42.24 2.11l-.98.22ZM3.79 18.55c-.49-.61-.91-1.28-1.25-1.99l.9-.44c.31.64.69 1.25 1.13 1.8l-.78.62v.01ZM7.44 21.46c-.71-.34-1.38-.76-1.99-1.25l.62-.78c.56.44 1.16.83 1.8 1.13l-.43.9ZM12 22.5c-.79 0-1.57-.09-2.34-.26l.22-.97c.69.16 1.41.24 2.12.24 5.24 0 9.5-4.26 9.5-9.5S17.24 2.5 12 2.5v-1c5.79 0 10.5 4.71 10.5 10.5S17.79 22.5 12 22.5Z" />
  </IconWrapper>
)

export default ProgressIndicatorSpinnerIconMedium
